import type { ErrorResponseResult } from "@adjust/website/libs/fetcher/errors";
import { EJSON } from "bson";

export class PromiseWrapper<Response> {
  private promise: Promise<Response>;
  constructor(promise: Promise<Response>) {
    this.promise = promise;
  }

  then(onfulfilled?: (value: Response) => void) {
    this.promise.then(onfulfilled);
    return this;
  }

  catch(onrejected?: (error: ErrorResponseResult) => void) {
    function rejected(error: any) {
      if (error instanceof Error) return console.error(error);
      return onrejected?.(error);
    }
    this.promise.catch(rejected);
    return this;
  }

  finally(onfinally?: () => void) {
    this.promise.finally(onfinally);
    return this;
  }
}

function createApiFetch<BodyType extends {}, ResponseType>(url: string, method: "POST" | "GET") {
  return function handler(body: BodyType) {
    return new PromiseWrapper<ResponseType>(
      new Promise(async (resolve, reject) => {
        try {
          const response = await fetch(url, {
            method: method,
            cache: "no-cache",
            credentials: "same-origin",
            body: EJSON.stringify(EJSON.serialize(body)),
          });
          const raw = await response.json();
          const data: any = EJSON.deserialize(raw);
          if (!response.ok) return reject(data);
          return resolve(data);
        } catch (error) {
          throw error;
        }
      }),
    );
  };
}

export default createApiFetch;
